// Do NOT add "use client" to this file
import { jsx as _jsx } from "react/jsx-runtime";
import { TileImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/TileImage";
import React from "react";
export var ProductTileImageBase = function(param) {
    var image = param.image, showVerticalImagery = param.showVerticalImagery, imageAltText = param.imageAltText, useLazyImageLoading = param.useLazyImageLoading, imageBreakpoints = param.imageBreakpoints, onLoad = param.onLoad;
    if (onLoad) {
        return /*#__PURE__*/ _jsx(TileImage, {
            image: image,
            showVerticalImagery: showVerticalImagery,
            imageAltText: imageAltText,
            useLazyImageLoading: useLazyImageLoading,
            imageBreakpoints: imageBreakpoints,
            onLoad: onLoad
        });
    }
    return /*#__PURE__*/ _jsx(TileImage, {
        image: image,
        showVerticalImagery: showVerticalImagery,
        imageAltText: imageAltText,
        useLazyImageLoading: useLazyImageLoading,
        imageBreakpoints: imageBreakpoints
    });
};
